import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  SortableRowContext,
  useSortableRowNode,
} from 'components/contentRegister/components/sortableTable/components/SortableRow';

export default function SortableRowGroup({
  children,
  elementId,
  expandedRow,
  rowClassName,
  sortableId,
  ...rowProps
}) {
  const {
    dragAttributes,
    dragListeners,
    isDragging,
    setActivatorNodeRef,
    setNodeRef,
    style,
  } = useSortableRowNode({ elementId, isSortable: true, sortableId });

  return (
    <SortableRowContext.Provider
      value={{
        dragAttributes,
        dragListeners,
        isDragging,
        isSortable: true,
        setActivatorNodeRef,
      }}
    >
      <tbody>
        <tr
          {...rowProps}
          className={classNames(rowClassName, isDragging && 'tw-opacity-0')}
          id={elementId}
          ref={setNodeRef}
          style={style}
        >
          {children}
        </tr>
        {expandedRow}
      </tbody>
    </SortableRowContext.Provider>
  );
}

SortableRowGroup.propTypes = {
  children: PropTypes.node.isRequired,
  elementId: PropTypes.string.isRequired,
  expandedRow: PropTypes.node,
  rowClassName: PropTypes.string,
  sortableId: PropTypes.string.isRequired,
};
